function getCommonConstructor(valueA, valueB) {
  if (valueA === undefined) return undefined;
  if (valueB === undefined) return undefined;
  if (valueA === null) return undefined;
  if (valueB === null) return undefined;
  let valueAConstructor = valueA.constructor;
  let valueBConstructor = valueB.constructor;
  if (valueAConstructor !== valueBConstructor) return undefined;
  return valueAConstructor;
}

export default {
  async loadExternalScript(scriptPath, { key = undefined } = {}) {
    if (window[key] !== undefined) return window[key];
    return new Promise((resolve, reject) => {
      let scriptElement = document.createElement('script');
      scriptElement.src = scriptPath;
      scriptElement.type = 'text/javascript';
      scriptElement.onload = () => { resolve(window[key]) };
      scriptElement.onerror = reject;
      document.head.appendChild(scriptElement);
    });
  },

  areRectsOverwrapped(rect1, rect2) {
    if ((rect1.x + rect1.width) <= rect2.x) {
      return false;
    }
    if (rect1.x >= (rect2.x + rect2.width)) {
      return false;
    }
    if ((rect1.y + rect1.height) <= rect2.y) {
      return false;
    }
    if (rect1.y >= (rect2.y + rect2.height)) {
      return false;
    }
    return true;
  },

  isRectInRect(rect1, rect2) {
    if (rect1.x < rect2.x) {
      return false;
    }
    if (rect1.y < rect2.y) {
      return false;
    }
    if ((rect1.y + rect1.height) < (rect2.y + rect2.height)) {
      return false;
    }
    if ((rect1.x + rect1.width) < (rect2.x + rect2.width)) {
      return false;
    }
    return true;
  },

  isInRect(rect, x, y) {
    if (rect.x > x) {
      return false;
    }
    if (rect.y > y) {
      return false;
    }
    if ((rect.x + rect.width) < x) {
      return false;
    }
    if ((rect.y + rect.height) < y) {
      return false;
    }
    return true;
  },

  getOffsetRectToBeInRect(rect1, rect2) {
    let offsetRect = new DOMRect(0, 0, rect1.width, rect1.height);
    if ((rect1.width > rect2.width) || (rect1.x < rect2.x)) {
      offsetRect.x = rect1.x - rect2.x;
    } else if ((rect1.x + rect1.width) >= (rect2.x + rect2.width)) {
      offsetRect.x = (rect1.x + rect1.width) - (rect2.x + rect2.width);
    }
    if ((rect1.height > rect2.height) || (rect1.y < rect2.y)) {
      offsetRect.y = rect2.y - rect1.y;
    } else if ((rect1.y + rect1.height) >= (rect2.y + rect2.height)) {
      offsetRect.y = (rect2.y + rect2.height) - (rect1.y + rect1.height);
    }
    return offsetRect;
  },

  clamp(x, min, max) {
    x = (x > max)? max : x;
    x = (x < min)? min : x;
    return x;
  },

  countNumLines(text) {
    let stringLength = text.length;
    let lineEndCount = 0;
    for (let i = 0; i < stringLength; ++i) {
      if (text[i] == '\n') {
        lineEndCount++;
      }
    }
    return lineEndCount + 1;
  },

  isSameAs(valueA, valueB, ignoreArrayOrder = false) {
    if ((valueA === null) && (valueB === null)) return true;
    let valueConstructor = getCommonConstructor(valueA, valueB);
    switch (valueConstructor) {
    case Object:
      return this.isSameObject(valueA, valueB, ignoreArrayOrder);
    case Array:
      return this.isSameArray(valueA, valueB, ignoreArrayOrder);
    default:
      if (Object.getOwnPropertyNames(valueConstructor.prototype).includes('isSameAs')) {
        return valueA.isSameAs(valueB);
      } else {
        return (valueA === valueB);
      }
    case undefined:
      return false;
    }
  },

  isSameArray(arrayA, arrayB, ignoreArrayOrder = false) {
    if (getCommonConstructor(arrayA, arrayB) !== Array) throw new TypeError();
    let numArrayAComponents = arrayA.length;
    let numArrayBComponents = arrayB.length;
    if (numArrayAComponents !== numArrayBComponents) return false;
    let numArrayComponents = numArrayAComponents;
    if (ignoreArrayOrder) {
      let foundSameIdcs = [];
      for (let valueA of arrayA) {
        let foundSameIdx = undefined;
        for (let idx = 0; idx < numArrayComponents; ++idx) {
          if (foundSameIdcs.includes(idx)) continue;
          let valueB = arrayB[idx];
          if (this.isSameAs(valueA, valueB, ignoreArrayOrder)) {
            foundSameIdx = idx;
            break;
          }
        }
        if (foundSameIdx === undefined) return false;
        foundSameIdcs.push(foundSameIdx);
      }
    } else {
      let numArrayAComponents = arrayA.length;
      for (let idx = 0; idx < numArrayAComponents; ++idx) {
        if (!this.isSameAs(arrayA[idx], arrayB[idx], ignoreArrayOrder)) return false;
      }
    }
    return true;
  },

  isSameObject(objectA, objectB, ignoreArrayOrder) {
    if (getCommonConstructor(objectA, objectB) !== Object) throw new TypeError();
    let keysOfObjectA = Object.keys(objectA);
    let keysOfObjectB = Object.keys(objectB);
    for (let keyOfObjectA of keysOfObjectA) {
      if (!keysOfObjectB.includes(keyOfObjectA)) return false;
    }
    for (let keyOfObjectB of keysOfObjectB) {
      if (!keysOfObjectA.includes(keyOfObjectB)) return false;
    }
    let keysOfObject = keysOfObjectA;
    for (let keyOfObject of keysOfObject) {
      if (!this.isSameAs(objectA[keyOfObject], objectB[keyOfObject], ignoreArrayOrder)) return false;
    }
    return true;
  },
};